package com.fireavert.react.events

import com.fireavert.react.pages.dashboard.styles.EventsStyles
import com.fireavert.react.pages.help.HelpDialog
import com.fireavert.react.pages.help.HelpDialog.TOOL_TIP_NEVER_INSTALLED
import com.fireavert.react.shared.styles.TableStyles
import emotion.css.ClassName
import emotion.css.cx
import emotion.react.css
import mui.material.IconButton
import mui.material.Tooltip
import mui.material.TooltipPlacement
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.div
import web.cssom.*

external interface UnitTotalCellProps : Props {
    var hasEvents: Boolean
    var style: ClassName
    var isOffline: Boolean
    var isActive: Boolean
    var activeIcon: String
    var text: String
    var isInstalled: Boolean
//    var fireRiskLevel: Int?
}

val UnitTotalCell = FC<UnitTotalCellProps> { props ->
    div {
        className = if (props.hasEvents) {
            cx(
                TableStyles.tableCellCentered,
                props.style,
                ClassName {
                    fontWeight = FontWeight.bold
                }
            )
        } else {
            TableStyles.tableCellCentered
        }
        if (props.isOffline and (props.style != EventsStyles.smokeText)) {
            div {
                css {
                    display = Display.flex
                    flexDirection = FlexDirection.row
                    alignItems = AlignItems.center
                    justifyContent = JustifyContent.center
                }
                div {
                    css { paddingBottom = 2.px }
                    +"${props.text} "
                }
                if (!props.isInstalled) {
                    Tooltip {
                        title = HelpDialog.toolTipText(TOOL_TIP_NEVER_INSTALLED)
                        placement = TooltipPlacement.top
                        IconButton {
                        ReactHTML.img {
                            src = "/static/warning_icon.svg"
                            alt = "Not Installed Icon"
                            className = TableStyles.activeIconNoMargin
                        }
                        }
                    }
                } else {
                    Tooltip {
                        title = HelpDialog.toolTipText("OFFLINE")
                        placement = TooltipPlacement.top
                        ReactHTML.img {
                            src = "/static/active_offline_icon.svg"
                            alt = "Offline"
                            className = TableStyles.activeIconNoMarginOffline
                        }
                    }
                }
            }

        } else if (props.isActive) {
            +" ${props.text}"
            ReactHTML.img {
                src = props.activeIcon
                alt = "Active"
                className = TableStyles.activeIconNoMargin
            }
//        } else if (props.fireRiskLevel != null) {
//            FireRiskLabelComponent {
//                riskLevel = RiskLevel.fromNumber(props.fireRiskLevel ?: 0) ?: RiskLevel.UNKNOWN
//            }
        } else {
            +props.text
        }
    }
}